<mat-nav-list [ngClass]="{'is-mobile-view': isMobileView}">
  <a mat-icon-button class="secondary-nav-toggler" (click)="onToggleSidenav()">
    <mat-icon>menu</mat-icon>
  </a>
</mat-nav-list>
<mat-nav-list *ngFor="let menuItem of menuItems" [ngClass]="{'is-mobile-view': isMobileView}">
  <a mat-icon-button
     routerLink="{{menuItem.url}}" routerLinkActive="active"
     [matTooltip]="getTooltipText(menuItem)" matTooltipPosition="after"
     [class.deprecated]="menuItem.badge == 'deprecated'"
  >
    <mat-icon *ngIf="menuItem.iconClass == 'material-icons'"
              [matBadge]="menuItem.notificationBadge > 99 ? 99 : menuItem.notificationBadge"
              matBadgeOverlap="true"
              matBadgeColor="warn"
              [matBadgeHidden]="!menuItem.notificationBadge"
    >{{menuItem.iconClassCode}}</mat-icon>

    <mat-icon *ngIf="menuItem.iconClass != 'material-icons'"
              fontSet="fa" [fontIcon]="menuItem.iconClass.replace('fa ', '')"
              style="font-size: 24px"
              [matBadge]="menuItem.notificationBadge > 99 ? 99 : menuItem.notificationBadge"
              matBadgeOverlap="true"
              matBadgeColor="warn"
              [matBadgeHidden]="!menuItem.notificationBadge"
    >{{menuItem.iconClassCode}}</mat-icon>
  </a>
</mat-nav-list>
